import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const addNewCategory = async (placeId, categoryId, update) => {
  if (!placeId || !categoryId || !update) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/category/${categoryId}/add`,
    data: update,
  });
};